







import { Vue, Component, VModel } from 'vue-property-decorator';

import { ContainsCondition } from ".";
import ListSetup from "../ListSetup.vue";

@Component({
  components: {
    ListSetup
  }
})
export default class ContainsSetting extends Vue {
  @VModel() model!: ContainsCondition
}
